import _pickBy from 'lodash/pickBy';
import { 
  DefaultBooleanValueString, 
  GlobalSettingType,
  DefaultBooleanValueNumber
} from '../../constants/enums';



const getValue = setting => {
  const { settingType, value } = setting;

  if (settingType === 'boolean') {
    if (value === '1') {
      return 'Verdadero';
    }
    return 'Falso';
  }

  if (!value) {
    return '--';
  }

  return value;
};

export const getGlobalSettings = ({ data }) => {
  return data.map(setting => ({
    ...setting,
    value: getValue(setting),
    tags: setting.tags.map(({ code }) => code)
  }));
};

export const saveGlobalSetting = params => {
  const { name, description, value, settingType, adminFromSb } = params;
  const sanitizedFilters = {
    name,
    description,
    value,
    adminFromSb
  };

  if (settingType == GlobalSettingType.Boolean) {
    sanitizedFilters.value = sanitizedFilters.value
     == DefaultBooleanValueNumber.True ? DefaultBooleanValueString.True : DefaultBooleanValueString.False;
  }

  return _pickBy(sanitizedFilters, filter => !!filter || filter === false);
};
